import axios from '@/axios.js'


export default {
  isRegistered: false,
  namespaced: true,
  state:{
    customers: []
  },
  mutations:{
    SET_CUSTOMERS (state, customers) {
      state.customers = customers
    },
    ADD_RECORD (state, item) {
      state.customers.push({
        uuid: item.uuid,
        name: item.name,
        idno: item.idno,
        dob: item.dob,
        contact: item.contact,
        address: item.address,
        career: item.career,
        remark: item.remark,
        status: item.status,
        groupid: item.groupid
      })
    },
    UPDATE_RECORD (state, item) {
      const userIndex = state.customers.findIndex((u) => u.uuid === item.uuid)
      state.customers[userIndex].name = item.name
      state.customers[userIndex].idno = item.idno
      state.customers[userIndex].dob = item.dob
      state.customers[userIndex].contact = item.contact
      state.customers[userIndex].address = item.address
      state.customers[userIndex].career = item.career
      state.customers[userIndex].remark = item.remark
      state.customers[userIndex].status = item.status
      state.customers[userIndex].groupid = item.groupid
      state.customers[userIndex].pictures = item.pictures
    },
    UPDATE_STATUS (state, item) {
      const userIndex = state.customers.findIndex((u) => u.uuid === item.uuid)
      let current_status = state.customers[userIndex].status
      state.customers[userIndex].status = current_status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
    },
    UPDATE_DEPENDENT (state, item) {
      const userIndex = state.customers.findIndex((u) => u.uuid === item.uuid)
      state.customers[userIndex].dependents = item.dependents
    },
    REMOVE_RECORD (state, itemId) {
      const userIndex = state.customers.findIndex((u) => u.uuid === itemId)
      state.customers.splice(userIndex, 1)
    }
  },
  actions:{
    fetchCustomerImages ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/customer/pictures/list',data.form_data)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addCustomerImage ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/customer/pictures`,data.form_data)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateCustomerImage ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/customers/${data.uuid}`,data.form_data)
          .then((response) => {
            commit('UPDATE_RECORD', data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },


    fetchCustomers ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/customers/list',data.form_data)
          .then((response) => {
            console.log("customer data",response.data.data)
            commit('SET_CUSTOMERS', response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addRecord ({ commit }, data) {
      console.log('customer addRecord', data)
      return new Promise((resolve, reject) => {
        axios.post(`/customers`,data.form_data)
          .then((response) => {
            console.log('addRecord response',response)
            // data.uuid = response.data.data.id

            // Handle different possible response structures for customer ID
            let customerId = null;
            
            if (response.data && response.data.data && response.data.data.id) {
              customerId = response.data.data.id;
            } else if (response.data && response.data.data && response.data.data.uuid) {
              customerId = response.data.data.uuid;
            } else if (response.data && response.data.id) {
              customerId = response.data.id;
            } else if (response.data && response.data.uuid) {
              customerId = response.data.uuid;
            } else {
              console.warn('No customer ID found in response:', response.data);
              // Generate a temporary UUID as fallback
              customerId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            }
            
            data.uuid = customerId;

            commit('ADD_RECORD', data)
            resolve(response)
          })
          .catch((error) => { 
            console.error('Error adding customer:', error);
            reject(error) 
          })
      })
    },
    updateRecord ({ commit }, data) {
      console.log('customer updateRecord',data)
      return new Promise((resolve, reject) => {
        axios.post(`/customers/${data.uuid}`,data.form_data)
          .then((response) => {
            commit('UPDATE_RECORD', data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateStatus ({ commit }, data) {
      console.log('customer updateStatus',data)
      return new Promise((resolve, reject) => {
        axios.post(`/customers/${data.uuid}`,data.form_data)
          .then((response) => {
            commit('UPDATE_STATUS', data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateContact ({ commit }, data) {
      console.log('customer updateContact',data)
      return new Promise((resolve, reject) => {
        axios.post(`/customers/${data.uuid}`,data.form_data)
          .then((response) => {
            commit('UPDATE_DEPENDENT', data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    deleteCustomer ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.delete(`/customers/${data.uuid}`)
          .then((response) => {
            commit('REMOVE_RECORD', data.uuid)
            resolve(response)
          })
          .catch((error) => { 
            console.error('Error deleting customer:', error);
            // If DELETE doesn't work, try POST method (some APIs use POST for delete)
            if (error.response && error.response.status === 405) {
              // Method not allowed, try POST instead
              return axios.post(`/customers/${data.uuid}`, { _method: 'DELETE' })
                .then((response) => {
                  commit('REMOVE_RECORD', data.uuid)
                  resolve(response)
                })
                .catch((err) => reject(err))
            }
            reject(error) 
          })
      })
    },
    
  },
  getters:{

  }
}

